import { Card,Form, Input, Radio } from 'antd';
import React, { useEffect } from 'react';
import { ToothSample, User } from '../../../models';
import { loginInfo } from '../../../config';
interface PropsType {
  editRecord: ToothSample;
  setAge: Function;
}
export const HospitalPerson: React.FC<PropsType> = ({ editRecord, setAge }) => {
  const [form] = Form.useForm();
  useEffect(() => {
    if(editRecord.id === -1){
      editRecord.hospitalId = loginInfo.user.hospitalId;
      editRecord.hospitalName = loginInfo.user.hospitalName;
      form.setFieldsValue({schoolName:'',gradeName:'',className:'',name:'',sex:'',age:'',ageMonth:'',phoneNo:'',sender:'',checker:''})
    }
    form.setFieldsValue({...editRecord});
    
  }, [editRecord, form, loginInfo.user]);
  
  const onItemChange = (e: any) => {
    editRecord.sex = form.getFieldValue("sex");
    editRecord.name = form.getFieldValue("name");
    editRecord.className = form.getFieldValue("className");
    editRecord.gradeName = form.getFieldValue("gradeName");
    editRecord.schoolName = form.getFieldValue("schoolName");
    editRecord.phoneNo = form.getFieldValue("phoneNo");
    editRecord.sender = form.getFieldValue("sender");
    editRecord.checker = form.getFieldValue("checker");
    editRecord.ageMonth = parseInt(form.getFieldValue("ageMonth"));
  }
  const onAgeChange = (e) => {
    let age1 = parseInt(e.target.value);
    editRecord.age = age1;
    setAge(age1);
  }
  
  return (
    <Card title="受检人信息" style={{ background: "#ececec", margin: "10px" }}>

      <Form layout="horizontal"
        labelCol={{ span: 12 }}
        wrapperCol={{ span: 12 }}
        form={form}>
        
        <Form.Item
          name="hospital"
          label='检测医院'
        >
          <span>{editRecord.hospitalName}</span>
        </Form.Item>

        <Form.Item
          name="schoolName"
          label='学校/幼儿园'
        >
          <Input onChange={onItemChange} placeholder="请输入" />
        </Form.Item>
        <Form.Item
          name="gradeName"
          label='所在年级'
        ><Input onChange={onItemChange} placeholder="请输入" />
        </Form.Item>

        <Form.Item
          name="className"
          label='所在班级'
        ><Input onChange={onItemChange} placeholder="请输入" />
        </Form.Item>

        <Form.Item
          name="name"
          label='姓名'
        >
          <Input onChange={onItemChange} placeholder="请输入" />
        </Form.Item>

        <Form.Item
          name="sex"
          label='性别'
        >
          <Radio.Group onChange={onItemChange}>
            <Radio value={"男"}>男</Radio>
            <Radio value={"女"}>女</Radio>
          </Radio.Group>

        </Form.Item>
        
            <Form.Item name="age" label="年龄(岁)">
              <Input onChange={onAgeChange} />
            </Form.Item>
            <Form.Item name="ageMonth" label="年龄(月)">
              <Input onChange={onItemChange} />
            </Form.Item>
        

        <Form.Item
          name="phoneNo"
          label='电话号码'
        >
          <Input onChange={onItemChange} />
        </Form.Item>
        <Form.Item name="sender" label="送检者">
              <Input onChange={onItemChange} />
            </Form.Item>
            <Form.Item name="checker" label="检测医生">
              <Input onChange={onItemChange} />
            </Form.Item>
      </Form>
    </Card>
  );
}